import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { GlobalService } from '../../services/global/global.service';

@Component({
  selector: 'app-whatsapp-number-input',
  templateUrl: './whatsapp-number-input.component.html',
  styleUrls: ['./whatsapp-number-input.component.scss'],
})
export class WhatsappNumberInputComponent implements OnInit {
  whatsappForm!: FormGroup;

  leadPhone: any;

   @Input() onActionPerformed!: (data: any) => void;

  constructor(private fb: FormBuilder,
    private _popoverController: PopoverController,
    private _globalService: GlobalService
  ) {}

  async ngOnInit(): Promise<void> {
    const organization = await this._globalService.getLoggedInOrgDetails();
    
    if(!organization || !organization?.metaSettings || !organization?.metaSettings?.apiKey || !organization?.metaSettings?.phoneNumberId ){
      await this._globalService.customAlert('WhatsApp integration is not set up for this organization. Please contact support.', 'Please Contact Support');
      this.closeModal();
      return;
    }

    this.whatsappForm = this.fb.group({
      whatsappNumber: ['', [ Validators.required ]],
    });

    if(this.leadPhone){
      this.whatsappForm.patchValue({ whatsappNumber: this.leadPhone });
    }
  }

  onSubmit(): void {
    if (this.whatsappForm.valid) {
      this.onActionPerformed(this.whatsappForm.value);
      this.closeModal();
    } else {
      this.whatsappForm.markAllAsTouched();
    }
  }

  closeModal() {
    this._popoverController.dismiss();
  }
}
